angular.module('app.shared.teamService', [])
  .factory('app.shared.teamService', [
    '$http', '$httpParamSerializerJQLike',
    function ($http, $httpParamSerializerJQLike) {
      return {
        getTeam: function (teamId) {
          return $http.get(window.location.api('teams/' + teamId));
        },
        getTeams: function (filter) {
          if (filter) {
            filter = '?filter=' + filter;
          }
          else {
            filter = '';
          }

          return $http.get(window.location.api('teams' + filter));
        },
        getByAccess: (options) => {
          options = $httpParamSerializerJQLike(options);
          return $http.get(window.location.api(`teams_by_access?${options}`));
        },
        getOpponents: (team_id, options) => {
          options = $httpParamSerializerJQLike(options);
          return $http.get(window.location.api(`teams/${team_id}/opponents?${options}`));
        },
        getTeamsOpponents: (options) => {
          options = $httpParamSerializerJQLike(options);
          return $http.get(window.location.api(`teams_opponents?${options}`));
        },
        getPlayers: (team_id, options) => {
          options = $httpParamSerializerJQLike(options);
          return $http.get(window.location.api(`teams/${team_id}/players?${options}`));
        },
        getTeamsPlayers: (options) => {
          options = $httpParamSerializerJQLike(options);
          return $http.get(window.location.api(`teams_players?${options}`));
        }
      };
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/shared/teamService.js